module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "imc"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/tools/imc.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Indice de masse corporelle")]), _vm._v(" "), _c('div')])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-card', {
    staticClass: "mycard",
    attrs: {
      "to": "imc-weightloss-calc"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/tools/bariatric.jpg",
      "height": "250px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("IMC et perte de poids après chirurgie")]), _vm._v(" "), _c('div')])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d32763f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tools/Tools.vue
// module id = 1201
// module chunks = 1